
class modalSureCtrl {
    constructor($scope, $uibModalInstance, items1) {
        $scope = $.extend($scope, items1)
        $scope.totalMoney = 0
        $scope.totalTax = 0
        $scope.invoiceList.forEach((element) => {
            $scope.totalMoney += element.totalAmt
            $scope.totalTax += element.totalTaxamt
        })
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) { 
            $uibModalInstance.close()
        }
    }
}

modalSureCtrl.$inject = ['$scope', '$uibModalInstance', 'items1']
export default modalSureCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/modalSureCtrl.js